import { withInstall, withNoopInstall } from '@sgui-plus/utils'
import Carousel from './src/carousel.vue'
import CarouselItem from './src/carousel-item.vue'

export const SgCarousel = withInstall(Carousel, {
  CarouselItem,
})

export default SgCarousel

export const SgCarouselItem = withNoopInstall(CarouselItem)

export * from './src/carousel'
export * from './src/carousel-item'
export * from './src/constants'

export type { CarouselInstance, CarouselItemInstance } from './src/instance'
